import type { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface StatCardProps {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  icon?: ReactNode;
  accentColor?: string;
}

export default function StatCard({ label, value, hint, icon, accentColor }: StatCardProps) {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
          <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', fontWeight: 700 }}>
            {label}
          </Typography>
          {icon ? (
            <Box
              sx={{
                width: 36,
                height: 36,
                borderRadius: '2px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                bgcolor: accentColor ? `${accentColor}26` : 'action.selected',
                color: accentColor ?? 'primary.main',
              }}
            >
              {icon}
            </Box>
          ) : undefined}
        </Stack>
        <Typography variant="h2" sx={{ mt: 1.5 }}>
          {value}
        </Typography>
        {hint ? (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {hint}
          </Typography>
        ) : undefined}
      </CardContent>
    </Card>
  );
}
